import { render, staticRenderFns } from "./AddDetailOrder.vue?vue&type=template&id=cd4b8798&"
import script from "./AddDetailOrder.vue?vue&type=script&lang=js&"
export * from "./AddDetailOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddDetailOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports